<ng-container *ngIf="!isLoading">
  <div class="header" mat-dialog-actions>
    <div class="navigation desktop">
        <div class="left">
            <!-- <button (click)="duplicateInvoice()" mat-button>Duplicate</button> -->
            <button (click)="toggleIgnore()" mat-button>{{ transaction?.ignore ? 'Unignore' : 'Ignore' }}</button>
            <button (dblclick)="deleteTransaction()" mat-button color="warn">Delete</button>
        </div>
        <div class="middle">
            <button mat-button (click)="previous()">Previous</button>
            <button mat-button (click)="next()">Next</button>
        </div>
        <div class="right">
            <button mat-button (click)="saveChangesAndClose()">Close</button>
        </div>
    </div>

    <div class="navigation mobile">
        <div class="left">
            <button mat-button mat-dialog-close><mat-icon>arrow_back</mat-icon></button>
        </div>
        <div class="middle">
            <button mat-button (click)="previous()">Previous</button>
            <button mat-button (click)="next()">Next</button>
        </div>
        <div class="right">
        </div>
    </div>
</div>


<mat-dialog-content>
    <div class="container">

        <div class="left-side" *ngIf="transaction">
          <ng-container [ngSwitch]="viewMode">
            <ng-container *ngSwitchCase="'preview'">
              <div class="receipt-preview" *ngIf="selectedReceipt as receipt">
                <div class="preview-header">
                  <div>
                    <p class="eyebrow">Linked receipt</p>
                    <h3>{{ receipt.file?.filename || 'Receipt' }}</h3>
                    <div class="meta">
                      <span class="pill ghost">{{ receipt.date ? (receipt.date | date:'dd MMM yyyy') : 'Date unknown' }}</span>
                      <span class="pill highlight">{{ formatReceiptAmount(receipt) }}</span>
                    </div>
                  </div>
                  <div class="preview-actions">
                    <a *ngIf="receipt.file" [href]="receiptsService.getReceiptURL(receipt)" target="_blank" mat-stroked-button>
                      <mat-icon>open_in_new</mat-icon>
                      Open
                    </a>
                    <button mat-stroked-button (click)="setViewMode('matcher')">
                      <mat-icon>tune</mat-icon>
                      Manage receipts
                    </button>
                    <button mat-button color="warn" (click)="unlinkReceipt(receipt)">Unlink</button>
                  </div>
                </div>

                <div class="receipt-switcher" *ngIf="receipts.length > 1">
                  <button
                    mat-stroked-button
                    class="switcher-pill"
                    *ngFor="let r of receipts"
                    [class.active]="r.sha1 === selectedReceiptSha1"
                    (click)="selectReceipt(r)">
                    {{ r.file?.filename || 'Receipt' }}
                  </button>
                </div>

                <div class="viewer" *ngIf="receipt.file; else missingReceiptFile">
                  <ng-container [ngSwitch]="receipt.file?.type">
                    <img *ngSwitchCase="MediaType.IMAGE" [src]="receiptsService.getReceiptURL(receipt)" class="image-viewer">
                    <pdf-viewer
                      *ngSwitchCase="MediaType.PDF"
                      [src]="receiptsService.getReceiptURL(receipt)"
                      [render-text]="true"
                      [fit-to-page]="true"
                      [original-size]="false"
                      style="display: block;height:100%;"
                      class="pdf-viewer"></pdf-viewer>
                    <div *ngSwitchDefault class="unsupported">Unsupported or unknown receipt type.</div>
                  </ng-container>
                </div>
                <ng-template #missingReceiptFile>
                  <div class="empty-state">
                    <p>Receipt file missing or not yet uploaded.</p>
                  </div>
                </ng-template>
              </div>
            </ng-container>

            <ng-container *ngSwitchDefault>
              <div class="receipt-matcher">
                <div class="matcher-header">
                  <div class="summary">
                    <p class="eyebrow">Receipt matcher</p>
                    <h3>{{ transaction.description || 'Transaction' }}</h3>
                    <div class="meta">
                      <span class="pill ghost">{{ transaction.date | date:'EEE, dd MMM' }}</span>
                      <span class="pill highlight">{{ human(transaction.amount) }}</span>
                    </div>
                    <p class="hint">Match an existing receipt or upload a new one. Suggestions look for close dates and amounts.</p>
                  </div>
                  <div class="upload-actions">
                    <button mat-stroked-button type="button" (click)="logTransaction()">
                      <mat-icon>terminal</mat-icon>
                      Console log
                    </button>
                    <button mat-stroked-button color="primary" (click)="triggerReceiptUpload()">
                      <mat-icon>cloud_upload</mat-icon>
                      Upload receipt
                    </button>
                    <input #receiptFileInput class="hidden-file-input" type="file" (change)="handleReceiptFile($event.target.files)">
                  </div>
                </div>
                <div class="receipt-dropzone">
                  <ngx-dropzone *ngIf="!receiptUploadProgress.visible" (change)="handleReceiptDrop($event)" accept="image/*,application/pdf">
                    <ngx-dropzone-label>
                      <div class="dropzone-label">
                        <mat-icon>upload_file</mat-icon>
                        <div>
                          <div class="title">Drop receipt file</div>
                          <div class="subtitle">PDF or image. Drag it here or click to browse.</div>
                        </div>
                      </div>
                    </ngx-dropzone-label>
                  </ngx-dropzone>

                  <div *ngIf="receiptUploadProgress.visible" class="receipt-upload-progress" [class.completed]="receiptUploadProgress.completed">
                    <div class="receipt-upload-progress-header">
                      <span>{{ receiptUploadProgress.phase }}</span>
                      <span>{{ receiptUploadProgress.percent !== null ? receiptUploadProgress.percent + '%' : 'total unknown' }}</span>
                    </div>
                    <div class="receipt-upload-progress-body">
                      <span>{{ receiptUploadProgress.fileName }}</span>
                      <span>
                        {{ formatBytes(receiptUploadProgress.loaded) }}
                        /
                        {{ receiptUploadProgress.total ? formatBytes(receiptUploadProgress.total) : 'unknown' }}
                      </span>
                    </div>
                    <div class="receipt-upload-progress-track">
                      <div
                        class="receipt-upload-progress-fill"
                        [style.width.%]="receiptUploadProgress.percent || 0">
                      </div>
                    </div>
                  </div>
                </div>

                <div class="invoice-search-section">
                  <div class="section-heading">
                    <div>
                      <span>Invoice search</span>
                      <span class="meta">Attach an invoice PDF as the receipt</span>
                    </div>
                  </div>

                  <div class="invoice-search-controls">
                    <ap-search
                      [fullWidth]="true"
                      placeholder="invoice number"
                      [query]="invoiceQuery"
                      (onChange)="onInvoiceQueryChange($event)"
                      (cancelled)="onInvoiceCancelled()"
                    ></ap-search>

                    <ap-search
                      [fullWidth]="true"
                      placeholder="invoice amount"
                      [query]="invoiceAmountQuery"
                      (onChange)="onInvoiceAmountQueryChange($event)"
                      (cancelled)="onInvoiceAmountCancelled()"
                    ></ap-search>
                  </div>

                  <div *ngIf="isSearchingAnyInvoice && combinedInvoices.length" class="loading-inline">
                    Updating invoice matches...
                  </div>

                  <div *ngIf="isSearchingAnyInvoice && !combinedInvoices.length" class="invoice-progress">
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                    <span>Searching invoices...</span>
                  </div>

                  <div *ngIf="showInvoiceEmptyState" class="empty-state">
                    <p>Search by exact invoice number or exact total amount.</p>
                  </div>

                  <div *ngIf="invalidInvoiceQuery" class="empty-state">
                    <p>Invoice number search only accepts numbers.</p>
                  </div>

                  <div *ngIf="invalidInvoiceAmountQuery" class="empty-state">
                    <p>Invoice amount search only accepts dollar amounts.</p>
                  </div>

                  <div *ngIf="showInvoiceNoResults" class="empty-state">
                    <p>No invoices matched the current search.</p>
                  </div>

                  <div *ngIf="combinedInvoices.length" class="receipt-list invoice-results">
                    <div class="receipt-row" *ngFor="let invoice of combinedInvoices">
                      <div class="receipt-meta">
                        <div class="name">Invoice #{{ invoice.number }}</div>
                        <div class="subtext">
                          <span>{{ invoice.customer?.name || 'No customer' }}</span>
                          <span class="dot">&middot;</span>
                          <span>{{ invoice.dateCreated | date:'dd MMM yyyy' }}</span>
                          <span class="dot">&middot;</span>
                          <span>{{ human(invoice.total) }}</span>
                          <span class="pill soft">{{ invoice.status || 'unknown' }}</span>
                        </div>
                        <button
                          type="button"
                          class="invoice-warning"
                          *ngIf="getInvoiceAttachmentWarning(invoice) as warning"
                          (click)="openInvoiceAttachmentWarning(invoice)">
                          <mat-icon>warning</mat-icon>
                          <span>{{ warning.message }}</span>
                          <mat-icon>open_in_new</mat-icon>
                        </button>
                      </div>
                      <div class="actions">
                        <button mat-stroked-button (click)="openInvoice(invoice)">
                          <mat-icon>open_in_new</mat-icon>
                          Open
                        </button>
                        <button
                          mat-stroked-button
                          color="primary"
                          (click)="attachInvoice(invoice)"
                          [disabled]="attachingInvoiceNumber === invoice.number">
                          <mat-icon>link</mat-icon>
                          {{ attachingInvoiceNumber === invoice.number ? 'Attaching' : 'Attach' }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="invoiceSearchMessage" class="invoice-message">
                    {{ invoiceSearchMessage }}
                  </div>
                </div>

                <div class="matched-section">
                  <div class="section-heading">
                    <span>Matched receipts</span>
                    <span *ngIf="receipts.length" class="count-pill">{{ receipts.length }}</span>
                  </div>
                  <div *ngIf="receipts.length; else noMatched" class="receipt-list">
                    <div class="receipt-row" *ngFor="let receipt of receipts">
                      <div class="receipt-meta">
                        <div class="name">{{ receipt.file?.filename || 'Receipt' }}</div>
                        <div class="subtext">
                          <span>{{ receipt.date ? (receipt.date | date:'dd MMM yyyy') : 'Date unknown' }}</span>
                          <span class="dot">&middot;</span>
                          <span>{{ formatReceiptAmount(receipt) }}</span>
                        </div>
                        <div class="receipt-note" *ngIf="receipt.note">
                          <mat-icon>sticky_note_2</mat-icon>
                          <span>{{ receipt.note }}</span>
                        </div>
                      </div>
                      <div class="actions">
                        <a *ngIf="receipt.file" [href]="receiptsService.getReceiptURL(receipt)" target="_blank" mat-stroked-button>
                          <mat-icon>open_in_new</mat-icon>
                          View
                        </a>
                        <button mat-button color="warn" (click)="unlinkReceipt(receipt)">Unlink</button>
                      </div>
                    </div>
                  </div>
                  <ng-template #noMatched>
                    <div class="empty-state">
                      <p>No receipts linked yet. Use suggestions or upload to match one.</p>
                    </div>
                  </ng-template>
                </div>

                <div class="suggestions-section">
                  <div class="section-heading">
                    <div>
                      <span>Suggested receipts</span>
                      <span class="meta">Looking in unsorted queue</span>
                    </div>
                    <button mat-button (click)="refreshSuggestedReceipts()" [disabled]="isLoadingSuggestions">
                      <mat-icon>refresh</mat-icon>
                      Refresh
                    </button>
                  </div>
                  <div *ngIf="isLoadingSuggestions" class="loading-inline">Finding suggestions...</div>
                  <div *ngIf="!isLoadingSuggestions && suggestedReceipts.length" class="receipt-list">
                    <div class="receipt-row" *ngFor="let receipt of suggestedReceipts">
                      <div class="receipt-meta">
                        <div class="name">{{ receipt.file?.filename || 'Untitled receipt' }}</div>
                        <div class="subtext">
                          <span>{{ receipt.date ? (receipt.date | date:'dd MMM yyyy') : 'No date provided' }}</span>
                          <span class="dot">&middot;</span>
                          <span>{{ formatReceiptAmount(receipt) }}</span>
                          <span *ngIf="receipt._matchReason" class="pill soft">{{ receipt._matchReason }}</span>
                        </div>
                        <div class="receipt-note" *ngIf="receipt.note">
                          <mat-icon>sticky_note_2</mat-icon>
                          <span>{{ receipt.note }}</span>
                        </div>
                      </div>
                      <div class="actions">
                        <button mat-stroked-button color="primary" (click)="attachReceipt(receipt)">
                          <mat-icon>link</mat-icon>
                          Match
                        </button>
                        <a *ngIf="receipt.file" [href]="receiptsService.getReceiptURL(receipt)" target="_blank" mat-icon-button>
                          <mat-icon>open_in_new</mat-icon>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!isLoadingSuggestions && !suggestedReceipts.length" class="empty-state">
                    <p>No obvious matches yet. Upload the receipt or adjust its date/amount.</p>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>

        <div class="properties" *ngIf="transaction !== undefined">
            
          <div class="content">

            <ng-container [ngSwitch]="transactionType">
              <ng-container *ngSwitchCase="TransactionType.Expense">
                <div class="">  
                  <div class="transaction-date-row">
                    <input-note [note]="transaction.date | date:'dd/MM/yy'"></input-note>
                    <button mat-stroked-button type="button" (click)="moveTransactionDateBackOneDay()">
                      <mat-icon>keyboard_arrow_left</mat-icon>
                      1 day
                    </button>
                  </div>
                  <input-note [note]="transaction.description"></input-note>
                  <input-text (save)="updateNote($event)" label="Note" [(inputValue)]="transaction.note"></input-text>
                  <input-money label="Amount" [readonly]="true" [inputValue]="transaction.amount"></input-money>
                  <input-money label="GST" [readonly]="true" [inputValue]="transaction.vat"></input-money>
                  <input-select (save)="updatePreset($event)" label="Preset" [inputValue]="transaction.preset || transaction.subcategory || ''" [options]="transactionPresetOptions"></input-select>
                  <input-radio (save)="hasGSTRadio($event)" label="Has GST" [inputValue]="transaction.vat < 0"></input-radio>
                  <input-radio (save)="requresEvidence($event)" label="Requires Evidence" [inputValue]="!transaction.internal"></input-radio>
    
                  <input-select (save)="updateATOCategory($event)" label="Cost of Goods" [(inputValue)]="transaction.atocategory" [options]="COGS"></input-select>
                  <input-select (save)="updateATOCategory($event)" label="Operating Expense" [(inputValue)]="transaction.atocategory" [options]="operatingExpenses"></input-select>
    
                  <div class="evidence-list" *ngFor="let proof of transaction.proof; let i = index">
                    <div>#{{i}}</div>
                    <div class="evidence-link"><a (click)="viewEvidence(transaction.source.sha1, proof.sha1)" [title]="proof.fileName">{{proof.fileName.substring(0, 60)}}</a></div>
                    <div><button mat-button (dblclick)="deleteEvidence(transaction.source.sha1, proof.sha1)">Delete</button></div>
                  </div>
                </div>           
              </ng-container>
              
              <ng-container *ngSwitchCase="transactionType">
                <div class="transaction-date-row">
                  <input-note [note]="transaction.date | date:'dd/MM/yy'"></input-note>
                  <button mat-stroked-button type="button" (click)="moveTransactionDateBackOneDay()">
                    <mat-icon>keyboard_arrow_left</mat-icon>
                    1 day
                  </button>
                </div>
                <input-note [note]="transaction.description"></input-note>
                <input-text (save)="updateNote($event)" label="Note" [(inputValue)]="transaction.note"></input-text>
                <input-money label="Amount" [readonly]="true" [inputValue]="transaction.amount"></input-money>
                <input-money label="GST" [readonly]="true" [inputValue]="transaction.vat"></input-money>
                <input-select (save)="updatePreset($event)" label="Preset" [inputValue]="transaction.preset || transaction.subcategory || ''" [options]="transactionPresetOptions"></input-select>
                <input-money label="Desired invoice amount" (save)="setDesiredInvoiceAmount($event)" [inputValue]="transaction.additional?.desiredInvoiceAmount"></input-money>
                <input-radio (save)="saveSorted($event)" label="Sorted" [inputValue]="transaction.sorted"></input-radio>
                <input-radio (save)="requresEvidence($event)" label="Requires Evidence" [inputValue]="!transaction.internal"></input-radio>

                <div class="evidence-list" *ngFor="let proof of transaction.proof; let i = index">
                  <div>#{{i}}</div>
                  <div class="evidence-link"><a (click)="viewEvidence(transaction.source.sha1, proof.sha1)" [title]="proof.fileName">{{proof.fileName.substring(0, 60)}}</a></div>
                  <div><button mat-button (dblclick)="deleteEvidence(transaction.source.sha1, proof.sha1)">Delete</button></div>
                </div>
              </ng-container>

            </ng-container>
            </div>


            <div class="footer confirm-evidence" *ngIf="pendingEvidence">
              <mat-dialog-actions align="end">
                <button mat-raised-button mat-dialog-close>Cancel</button>
                <button (click)="applyPendingEvidence()" mat-raised-button color="warn">Apply</button>
              </mat-dialog-actions>
            </div>

        </div>
    </div>
</mat-dialog-content>
  
</ng-container>
